 
 
import AiAssistantView from '@/views/AiAssistantView.vue'
import AuthPageView from '@/views/AuthPageView.vue'
import DashBoardView from '@/views/DashBoardView.vue'
import LandingPageView from '@/views/LandingPageView.vue'
import PostView from '@/views/PostView.vue'
import SettingsView from '@/views/SettingsView.vue'
import TasklyView from '@/views/TasklyView.vue'
import { createRouter, createWebHistory } from 'vue-router'
 

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: AuthPageView
  },
  {
    
  
  
  path: '/dashboard/:groupId?', 
  name: 'Dashboard',
 component:DashBoardView,
  
  
  props: true 

  },
  {
    path:"/taskly",
    name:"taskly",
    component:TasklyView
  },
 {
  path: '/verify-email',
  name: 'VerifyEmail',
  component: () => import('../views/VerifyEmail.vue')
},
 {
  path:"/post",
  name:"post",
  component:PostView,
 },
 {
  path:"/ai-assistant",
  name:"ai-assistant",
  component:AiAssistantView,
 },
 {
  path:"/settings",
  name:"settings",
  component:SettingsView,
 },

 {
  path:"/",
  name:"landing",
  component:LandingPageView,
 }
 
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token");

  // while list of permetted routes
  const publicPages = ['/','/auth', '/verify-email'];
  const isPublicPage = publicPages.includes(to.path);

  if (!isPublicPage && !isAuthenticated) {
    //  if the useris not authenticated redict he to auth page
    next('/auth');
  } else if (to.path === '/auth' && isAuthenticated) {
    // if h is already authenticated redict he to the dashboard page
    next('/dashboard');
  } else {
    //  permet to user to pass to verify-email page 
    next();
  }
});




export default router
